import React, { ReactElement, ReactNode } from 'react';

import { isAxiosError } from 'axios';
import { ErrorBoundary } from 'react-error-boundary';
import { useQueryErrorResetBoundary } from 'react-query';

import ErrorFallback from './ErrorFallback';

interface Props {
  children: ReactNode | ReactElement;
}

const ApiErrorBoundary = ({ children }: Props) => {
  const { reset } = useQueryErrorResetBoundary();

  const authError = (error: Error) => {
    console.log('ERROR: ', error);
    if (
      isAxiosError(error) &&
      (error?.response?.status === 401 || error?.response?.status === 403)
    ) {
      console.log('AUTH ERROR : ', error);
      // 조건에 맞는 에러인 경우 이 ErrorBoundary에서 처리하지 않고
      // 상위 ErrorBoundary 위임을 위해 Throw
      throw error;
    } else {
      console.log('ERROR :', error);
      /** 기업 검색 > 상세조회 오류시 상위로 throw */
      if (
        isAxiosError(error) &&
        error?.request?.responseURL?.includes('/company/CP')
      ) {
        throw error;
      }
    }
  };

  return (
    <ErrorBoundary
      onReset={reset}
      // fallbackRender={({ resetErrorBoundary }) => (
      //   <div css={container}>
      //     <p>데이터를 불러오는데 실패하였습니다.</p>
      //     <Button
      //       label="다시 시도"
      //       theme="secondary"
      //       handleClick={() => resetErrorBoundary()}
      //     />
      //   </div>
      // )}
      FallbackComponent={ErrorFallback}
      // fallbackRender={ErrorFallback}
      onError={authError}
    >
      {children}
    </ErrorBoundary>
  );
};

export default ApiErrorBoundary;
